<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-form__row">
  <div class="slds-form__item" role="listitem">
    <div class="slds-form-element slds-form-element_horizontal">
      <label class="slds-form-element__label" for="resource-name">Resource Name</label>
      <div class="slds-form-element__control">
        <input (keyup)="onRestrictName($event)"
               class="slds-input"
               id="resource-name"
               placeholder="Search/restrict by name" type="text"/>
      </div>
    </div>
  </div>

  <div *ngIf="showGroup"
       class="slds-form__item" role="listitem">
    <div class="slds-form-element slds-form-element_horizontal">
      <label class="slds-form-element__label" for="select-rg">Resource Group</label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select (change)="onRestrictGroup($event)" class="slds-select" id="select-rg">
            <option value="">-all-</option>
            <option *ngFor="let op of this.groupOptions"
                    [value]="op">{{op}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showType"
       class="slds-form__item" role="listitem">
    <div class="slds-form-element slds-form-element_horizontal">
      <label class="slds-form-element__label" for="select-rt">Resource Type</label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select (change)="onRestrictType($event)" class="slds-select" id="select-rt">
            <option value="">-all-</option>
            <option *ngFor="let op of this.typeOptions"
                    [value]="op">{{op}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="showLocation"
       class="slds-form__item" role="listitem">
    <div class="slds-form-element slds-form-element_horizontal">
      <label class="slds-form-element__label" for="select-rl">Resource Location</label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select (change)="onRestrictLocation($event)" class="slds-select" id="select-rl">
            <option value="">-all-</option>
            <option *ngFor="let op of this.locationOptions"
                    [value]="op">{{op}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showSkillSet"
       class="slds-form__item" role="listitem">
    <div class="slds-form-element slds-form-element_horizontal">
      <label class="slds-form-element__label" for="select-rs">Skill Set</label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select (change)="onRestrictSkillSet($event)" class="slds-select" id="select-rs">
            <option value="">-all-</option>
            <option *ngFor="let op of this.skillSetOptions"
                    [value]="op">{{op}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

</div>
